import React, { useState, useEffect, useRef } from "react";
import Logo from "../img/Logo.png";
import { Link, useLocation } from "react-router-dom";
import { Navbar, Container, Nav } from "react-bootstrap";
import "./Navbar.css";
import {Home} from "../pages/home/Home";

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const ticking = useRef(false);

  //--- ADDED BY NEL - 07/03/2026
  const location = useLocation();
  useEffect(() => {
    console.log("Current URL:", window.location.href);
    console.log("Current Path:", location.pathname);
    console.log("Full Location Object:", location);
  }, [location]);
  //---

  // Transparent over the Hero, frosted glass once scrolled.
  useEffect(() => {
    const onScroll = () => {
      if (ticking.current) return;
      ticking.current = true;
      window.requestAnimationFrame(() => {
        setScrolled(window.scrollY > 60);
        ticking.current = false;
      });
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // const handleLoginClick = () => {
  //   window.location.href = "http://ciam.noser.com.ph";
  // };
  //--- ADDED BY NEL - 07/04/2026
  const handleLoginClick = () => {
    const currentUrl = encodeURIComponent(window.location.href);
    const targetUrl = `http://ciam.noser.com.ph/?returnTo=${currentUrl}`;
    
    console.log("Redirecting to:", targetUrl);
    window.location.href = targetUrl;
  };

  //--- ADDED BY NEL - 07/03/2026
  const handleRegisterClick = () => {
    window.location.href = "http://ciam.noser.com.ph/registration-form";
  };
  //---

  return (
    <Navbar
      collapseOnSelect
      expand="lg"
      variant="dark"
      sticky="top"
      className={`nz-nav ${scrolled ? "is-scrolled" : ""}`}
    >
      <Container fluid className="nz-nav__inner">
        <Navbar.Brand href={"/"} className="nz-nav__brand">
          <img src={Logo} width="40" height="40" alt="Noser Technology PH Corp" />
          <span>Noser Technology PH Corp</span>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" className="nz-nav__toggle" />
        <Navbar.Collapse id="responsive-navbar-nav" className="nz-nav__collapse">
          <Nav className="ml-auto nz-nav__links">
            <Link
              // to={`${process.env.PUBLIC_URL}/auth-login`}
              onClick={handleLoginClick}
              className="nz-nav__link nz-underline"
            >
              Login
            </Link>
            <Link
              // to={`${process.env.PUBLIC_URL}/auth/register/form`}
              to={`${process.env.PUBLIC_URL}/plans`}
              className="nz-nav__cta nz-pill"
            >
              Register
            </Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Header;
